// ACTIVATE:
// invoke initFormFieldsToggle() in main.ts if you need to add this hide / show feature for form fields
// EXAMPLE:
// you need to show additional fields if a specific option is selected
// and hide other non-related-fields
// HOW TO DO IT:
// add [data-toggler] to all the select fields, that make some extra fields appear
const initFormFieldsToggle = () => {
    const contactFormsArray = document.querySelectorAll("[contact-form]");
    if (contactFormsArray && contactFormsArray.length > 0) {
        contactFormsArray.forEach((form) => {
            const togglerArray = form.querySelectorAll("[data-toggler]");
            const elementsToBeToggledArray = document.querySelectorAll("[data-form-toggle-type]");
            togglerArray && togglerArray.length > 0 && togglerArray.forEach((toggler) => {
                //give it a first run to show correct data only
                toggleFormFields(elementsToBeToggledArray, toggler);
                //bind the function to the change event
                toggler.addEventListener("change", () => {
                    toggleFormFields(elementsToBeToggledArray, toggler);
                });
            });
        });
    }
};
//IF YOU WANT TO INSERT A NEW "data-form-toggle-type", THIS CODE HANDLES ONLY SINGLE WORDS
//SO MAKE THE VALUE OF THE OPTION AND THE ATTR BE JUST ONE WORD
//EXAMPLE: 
// OK => NEWTYPE, newtype, NewType
// NOT OK => NEW-TYPE, NEW TYPE
//IF YOU WANT AN ELEMENT TO BE AVAILABLE FOR MORE THAN ONE TYPE OF OPTION
//THEN SEPARE THE TYPES WITH ";"
//LIKE THIS "data-form-toggle-type="type1;type2"
const toggleFormFields = (array, selectToggler) => {
    array.forEach((element) => {
        if (element.getAttribute("data-form-toggle-type").split(";").includes(selectToggler.value.toLowerCase())) {
            element.classList.remove("hidden");
            if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
                element.removeAttribute('disabled');
            }
            else {
                element.querySelectorAll("input, select").forEach((input) => {
                    input.removeAttribute('disabled');
                });
            }
        }
        else {
            element.classList.add("hidden");
            if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
                element.disabled = true;
            }
            else {
                element.querySelectorAll("input, select").forEach((input) => {
                    input.disabled = true;
                });
            }
        }
    });
};
const initAttachedFile = () => {
    const attachedBtnList = document.querySelectorAll("[data-attached-btn]");
    if (attachedBtnList && attachedBtnList.length > 0) {
        attachedBtnList.forEach((attachedBtn) => {
            const attachedFileInput = attachedBtn.parentElement.querySelector("[data-input-attach-file]");
            attachedFileInput.addEventListener("change", () => {
                //Name of file and placeholder
                const file = attachedFileInput.files[0].name;
                const label = attachedBtn.querySelector("[data-text-file]");
                label.innerHTML = file;
            });
            attachedBtn.addEventListener("click", () => {
                if (attachedFileInput.classList.contains("error")) {
                    attachedBtn.classList.remove("error");
                    attachedFileInput.classList.remove("error");
                }
            });
        });
    }
};
